module.exports = __webpack_public_path__ + "img/symbol.72784733.png";